import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { MeterDefinitionsEditController, MeterDefinitionsEditScope } from './meter-definitions-edit.directive.controller'

import { IUserSession } from '../../../helpers/user-session'
import { ReferenceTypeService, REFERENCE_TYPE_SERVICE_NAME } from '../../../services/reference-type'
import { OperatorSecurityService, OPERATOR_SECURITY_SERVICE_NAME } from '../../../services/operator'

//#region Assets Imports

import './meter-definitions-edit.scss'
import * as TEMPLATE from './meter-definitions-edit.tpl.html'

//#endregion

export class MeterDefinitionsEditDirective implements ng.IDirective {
	constructor() {}
	restrict = 'E'
	scope = {
		source: '=?',
		id: '=?',
		schemaOwner: '=',
	}

	controller = [
		'$scope',
		'$q',
		'$timeout',
		'api',
		'logger',
		'localDictionary',
		'userSession',
		REFERENCE_TYPE_SERVICE_NAME,
		OPERATOR_SECURITY_SERVICE_NAME,
		(
			$scope: MeterDefinitionsEditScope,
			$q: ng.IQService,
			$timeout: ng.ITimeoutService,
			api: Api,
			logger: LoggerService,
			localDictionary: LocalDictionaryFactory,
			userSession: IUserSession,
			referenceTypeService: ReferenceTypeService,
			operatorSecurityService: OperatorSecurityService
		) => {
			return new MeterDefinitionsEditController($scope, $q, $timeout, api, logger, localDictionary, userSession, referenceTypeService, operatorSecurityService)
		},
	]

	template = TEMPLATE
}
